"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = {
    key: 0,
    class: "font-bold text-[20px] mb-3 uppercase"
};
const _hoisted_3 = {
    key: 1,
    class: "font-bold text-[20px] mb-3 uppercase"
};
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const SelectInput_vue_1 = __importDefault(require("../../components/Form/Select/SelectInput.vue"));
const CreateOrderRequest_1 = __importDefault(require("../../stores/checkout/CreateOrderRequest"));
const toastStore_1 = require("../../stores/toast/toastStore");
const checkoutStore_1 = require("../../stores/checkout/checkoutStore");
const i18n_1 = require("../../common/i18n");
const securityStore_1 = require("../../stores/security/securityStore");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const cartsStore_1 = require("../../stores/carts/cartsStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PaymentMode',
    props: {
        orderRequest: {
            type: CreateOrderRequest_1.default,
        },
        id: {
            type: String,
            default: () => { var _a; return `payment-mode-${(_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid}`; }
        }
    },
    setup(__props) {
        const props = __props;
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const checkoutStore = (0, checkoutStore_1.useCheckoutStore)();
        const router = (0, vue_router_1.useRouter)();
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const paymentModeOptions = (0, vue_3.computed)(() => checkoutStore.paymentModeOptions);
        const activeCart = (0, vue_3.computed)(() => cartsStore.activeCart);
        const customAddressFormSubmitted = (0, vue_3.computed)(() => checkoutStore.customAddressFormSubmitted);
        (0, vue_3.watch)(() => { var _a; return (_a = props.orderRequest) === null || _a === void 0 ? void 0 : _a.paymentModeId; }, (value, oldValue) => {
            if (props.orderRequest === undefined) {
                return;
            }
            if (value !== null) {
                checkoutStore
                    .getExtraFees(router, {
                    cartId: activeCart.value.id,
                    customAddress: props.orderRequest.shippingCustomerAddressId ===
                        "custom",
                    shippingModeId: props.orderRequest.shippingModeId,
                    paymentModeId: props.orderRequest.paymentModeId,
                })
                    .catch((error) => {
                    toastStore.addErrorToast(error.toString());
                });
            }
        });
        (0, vue_3.watch)([() => { var _a; return (_a = props.orderRequest) === null || _a === void 0 ? void 0 : _a.shippingModeId; }, paymentModeOptions, customAddressFormSubmitted], () => {
            if (props.orderRequest && paymentModeOptions.value.length) {
                const isCustomAddress = props.orderRequest.shippingCustomerAddressId === 'custom';
                if (!props.orderRequest.paymentModeId &&
                    1 <= paymentModeOptions.value.length &&
                    (!isCustomAddress ||
                        (isCustomAddress && customAddressFormSubmitted.value))) {
                    // csak akkor allitunk be kivalasztast, ha nincs kivalasztva semmi es legalabb egy valasztasi lehetoseg van
                    // illetve ha egyedi címet ad meg, és az egyedi cím form next gombjára rányomott
                    // eslint-disable-next-line vue/no-mutating-props
                    props.orderRequest.paymentModeId = paymentModeOptions.value[0].value;
                }
            }
        });
        (0, vue_3.onBeforeMount)(() => {
            checkoutStore.resetPaymentModes();
            checkoutStore.resetExtraFees();
        });
        return (_ctx, _cache) => {
            var _a, _b;
            return (__props.orderRequest !== undefined)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: 0,
                    id: __props.id,
                    class: "mb-3 border-b-2 border-[#929292]"
                }, [
                    (!((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("third_step_payment_mode", "3. step - Payment mode", "checkout")), 1))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((_b = (0, vue_2.unref)(currentUser)) === null || _b === void 0 ? void 0 : _b.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("fourth_step_payment_mode", "4. step - Payment mode", "checkout")), 1))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(paymentModeOptions).length > 0 &&
                        (__props.orderRequest.shippingCustomerAddressId !== 'custom' ||
                            (__props.orderRequest.shippingCustomerAddressId === 'custom' &&
                                (0, vue_2.unref)(customAddressFormSubmitted))))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SelectInput_vue_1.default, {
                            key: 2,
                            id: "payment-mode-select-input",
                            classes: "border-0",
                            class: "mb-5",
                            "placeholder-enable": true,
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('payment_modes_placeholder', 'Please select', 'checkout_payment_mode'),
                            modelValue: __props.orderRequest.paymentModeId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((__props.orderRequest.paymentModeId) = $event)),
                            options: (0, vue_2.unref)(paymentModeOptions)
                        }, null, 8, ["placeholder", "modelValue", "options"]))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
